import AIEstimatedLabel from './ai-estimated-label'

export default AIEstimatedLabel
